var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{class:[_vm.baseClass, { 'PrimaryButton': _vm.isPrimary ,'disabled-button': _vm.disabled}],style:({ width: _vm.buttonWidth }),attrs:{"loading":_vm.loadingBtn,"elevation":"0","disabled":_vm.disabled},on:{"click":_vm.handleClick}},[_vm._v(" "+_vm._s(_vm.buttonText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }